
import { Api, crudResourceCreator, setAuthToken, getAuthToken } from './apiHelper';
import config from '../config';

export function currentUser(){
  return Api.get(`/me`)
}

export function currentProject(id){
  if (id)
    localStorage.setItem('projectId', id)
  
  const projectId = localStorage.getItem('projectId')
  return Project.get({id: projectId || 'current'})
}

export function hasToken(){
  return getAuthToken()
}


export function logout(){
  setAuthToken(false)
  return {
    success_msg: "Logged out"
  }
}

export function tags(){
  return Tag.list()
}

export function scrapeUrl(params) {
  return Api.get(`${config.scraperEndpoint}/`, params)
}

export function scrapeFeed(params) {
  return Api.get(`${config.scraperEndpoint}/feed`, params)
}

export function scrapeLinksForImport(params) {
  return Api.get(`${config.scraperEndpoint}/import`, params)
}

export function scrapeSpecialPage(params) {
  return Api.get(`${config.scraperEndpoint}/page`, params)
}





const projectResourceOptions = {
  basePathMutator: (basePath) => {
    return (params) => {
      const projectId = params.project_id || localStorage.getItem('projectId')
      return [(projectId ? `/projects/${projectId}/${basePath.replace(/^\//, '')}` : basePath), params]
    }
  }
}


export const Session = crudResourceCreator(`/users/sign_in`, {only: ['create', 'destroy']})
export const User = crudResourceCreator(`/users`)
export const Project = crudResourceCreator(`/projects`)
export const PaymentMethod = crudResourceCreator(`/payment_methods`, {only: ['list', 'update', 'destroy']})

export const ResetPassword = crudResourceCreator(`/passwords`, {only: ['create', 'update']})


// Account Resources
export const Account = {
  ...crudResourceCreator(`/account`, {only: ['list', 'update']}), 
  updateSubscription: (params) => {
    // const extendParams 
    return Api.post(`/account/update_subscription`, params)
  },
  updatePaymentMethod: (params) => {
    // const extendParams 
    return Api.post(`/account/add_payment_method`, params)
  },
  deletePaymentMethod: (params) => {
    // const extendParams 
    return Api.delete(`/account/delete_payment_method`, params)
  },
  setDefaultPaymentMethod: (params) => {
    // const extendParams 
    return Api.post(`/account/default_payment_method`, params)
  }
}

// Coupon Resource
export const Coupon = {
  check: (params) => Api.post(`/coupons/check`, params),
  redeem: (params) => Api.post(`/coupons/redeem`, params)
}


// Project Resources
export const Member = crudResourceCreator(`/members`, projectResourceOptions)
export const Domain = {...crudResourceCreator(`/domains`, projectResourceOptions), 
  enableSSL: (params) => Api.put(projectResourceOptions.basePathMutator(`/domains/${params.id}/enable_ssl`))
}
export const PixelSet = crudResourceCreator(`/pixels`, projectResourceOptions)
export const Link = {...crudResourceCreator(`/links`, projectResourceOptions),
  randomSlug: () => Api.get(`/random_slug`),
  gsmPartnerInfo: () => Api.get(projectResourceOptions.basePathMutator('/get_gsm_partner_info'))
}
export const Tag = crudResourceCreator(`/tags`, {...projectResourceOptions, only: ['list']})

// Notifications
export const Notifications = crudResourceCreator(`/notifications`, {...projectResourceOptions, only: ['list']})



// WEBPACK FOOTER //
// ./src/api/index.js